import { OpportunityCss } from './OpportunityCss'
export function Opportunity() {
    return <OpportunityCss>
        <img src="	https://job-static.hirist.com/V2/static/media/bg.8b8bc9bc.svg" alt="" />
        <div className="opportunity-text">
            <p>
                <b>Premium Handpicked</b>
                <span>Jobs for you</span>
            </p>
            <p>Premium Handpicked Jobs that you will not find anywhere else</p>
        </div>
        <button className="RegisterBtn">
            Register Now!
        </button>
    </OpportunityCss>
}